import CustomerUser from "@/model/customerUser";

export interface IMCartCustomer {
  customer_code?: string;
  claim_code?: string;
  customer_name: string;
  postal_code: string;
  prefecture_code: string;
  prefecture_name: string;
  address_1: string;
  address_2: string;
  tel_number: string;
  industry_code: string;
}

export class MCartCustomerDTO implements IMCartCustomer {
  customer_code?: string;
  claim_code?: string;
  customer_name: string;
  postal_code: string;
  prefecture_code: string;
  prefecture_name: string;
  address_1: string;
  address_2: string;
  tel_number: string;
  industry_code: string;
  customer_users: MCartCustomer[];
  accounts: CustomerUser[];
  same_claim_code_accounts: CustomerUser[];
}

export default class MCartCustomer extends MCartCustomerDTO {
  constructor(dto?: MCartCustomerDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
      this.customer_users = this.customer_users
        ? this.customer_users.map((item) => {
          return new MCartCustomer(item);
        })
        : [];
    } else {
      this.new();
    }
  }
  public new() {
    Object.assign(this, {
      customer_code: "",
      claim_code: "",
      customer_name: "",
      postal_code: "",
      prefecture_code: "",
      prefecture_name: "",
      address_1: "",
      address_2: "",
      tel_number: "",
      industry_code: "",
      customer_users: [],
      accounts: [],
      same_claim_code_accounts: [],
    });
  }
  get formatPostalCode() {
    let postalCode = this.postal_code;
    console.log('MCartCustomer:', postalCode.includes('-'));
    if (!postalCode.includes('-')) {
      postalCode = postalCode.slice(0, 3) + '-' + postalCode.slice(-4);
    }

    return postalCode;
  }
  get code() {
    return this.customer_code + "-" + this.claim_code;
  }

  get customerUserNum() {
    return this.customer_users.length;
  }

  get accountsNum() {
    return this.accounts.length;
  }

  get sameClaimCodeAccountsNum() {
    return this.same_claim_code_accounts.length;
  }

  get address() {
    return "〒" + this.postal_code + "　" + this.prefecture_name + this.address_1.trim() + this.address_2.trim();
  }
}
